import { render, staticRenderFns } from "./AvailableWorkspacesBanner.vue?vue&type=template&id=25756560"
import script from "./AvailableWorkspacesBanner.vue?vue&type=script&lang=js"
export * from "./AvailableWorkspacesBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports